import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';
var templateUrl = require('./reportScheduleDetail.html');

class ReportScheduleDetailController extends ComponentController {
  readonly intervals: any[] = [
    { id: 1, label: 'Daily' },
    { id: 2, label: 'Weekly' },
    { id: 3, label: 'Monthly' }
  ];
  readonly times: any[] = _.flatten(
    _.map(['am', 'pm'], ampm => {
      return _.flatten(
        _.map([12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], hour => {
          return [`${hour}:00${ampm}`, `${hour}:30${ampm}`];
        })
      );
    })
  );
  readonly daysOfTheWeek: any[] = [
    { id: 1, label: 'Sunday' },
    { id: 2, label: 'Monday' },
    { id: 3, label: 'Tuesday' },
    { id: 4, label: 'Wednesday' },
    { id: 5, label: 'Thursday' },
    { id: 6, label: 'Friday' },
    { id: 7, label: 'Saturday' }
  ];
  readonly daysOfTheMonth: number[] = _.range(1, 29);

  canDelete: boolean;
  reportSchedule: any;

  constructor(
    private $state: any,
    private ReportScheduleService: any,
    private AuthService: any,
    private uibModal: any
  ) {
    super();
  }

  $onInit = () => {
    this.canDelete =
      this.reportSchedule.id && this.AuthService.hasPermission('Subscription', 'destroy');
  };

  saveReportSchedule = () => {
    this.ReportScheduleService.save(this.reportSchedule).then(() => {
      this.goToReportSchedules();
    });
  };

  deleteResource = () => {
    this.ReportScheduleService.delete(this.reportSchedule).then(() => {
      this.goToReportSchedules();
    });
  };

  confirmDelete = () => {
    this._confirmDelete(this.uibModal, this.reportSchedule, this.reportSchedule.epx_unit);
  };

  goToReportSchedules = () => {
    this.$state.go('admin.report-schedules');
  };
}

angular.module('ciApp').component('reportScheduleDetail', {
  templateUrl: templateUrl,
  bindings: {
    reportSchedule: '<',
    sites: '<'
  },
  controller: [
    '$state',
    'ReportScheduleService',
    'AuthService',
    '$uibModal',
    ReportScheduleDetailController
  ]
});



// WEBPACK FOOTER //
// ./app/admin/report-schedules/reportScheduleDetail.component.ts